import { render, staticRenderFns } from "./AppStoreDiscoverSection.vue?vue&type=template&id=bb597eea&scoped=true"
import script from "./AppStoreDiscoverSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppStoreDiscoverSection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppStoreDiscoverSection.vue?vue&type=style&index=0&id=bb597eea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb597eea",
  null
  
)

export default component.exports